import { useEffect, useState } from 'react'
import { format, utcToZonedTime } from 'date-fns-tz'
import { Typography } from '@mui/material'

export const LocalCurrentDateTime = () => {
  const [localCurrentDateTime, setLocalCurrentDateTime] = useState('')

  const setNewDateTime = () => {
    const now = new Date()

    const dateEST = utcToZonedTime(now, 'America/Los_Angeles')

    const dateFormated = format(dateEST, 'EEE, MMM dd, yyyy, hh:mm aa', {
      timeZone: 'America/Los_Angeles',
    })

    setLocalCurrentDateTime(dateFormated)
  }

  useEffect(() => {
    setNewDateTime()
    const interval = setInterval(setNewDateTime, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <Typography variant="caption">{`${localCurrentDateTime} PT`}</Typography>
  )
}
